(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_actions/quickplay/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/banner_actions/quickplay/assets/javascripts/init.js');
"use strict";


const _svs$banner_actions$q = svs.banner_actions.quickplay.initActions,
  addClickEvents = _svs$banner_actions$q.addClickEvents,
  keepModalOpen = _svs$banner_actions$q.keepModalOpen;
addClickEvents();
keepModalOpen();

 })(window);